import React, { useEffect } from "react"

//components
import { MinimalBreadcrumb, ThriveAppLogo } from "thrive-components";

//vars
import { SignUpStepRoutes, SignUpSteps, TOTAL_SIGNUP_STEPS } from "../../interfaces/Navigation";
import { useObservable } from "thrive-observable-react";
import { SUACService } from "../../services/SignUpAppConfig.service";

//styling
import "./nav-bar.scss";



const NavBar = ({}:{}) => {
    const currentStep = useObservable(SUACService.currentStep);
    const stepValues = Object.values(SignUpSteps);
    const currentStepNumber = stepValues.indexOf(currentStep);

    //onrefresh of page this will ensure correct breadcrumb is shown
    useEffect(() => {
        const step = (Object.keys(SignUpStepRoutes) as SignUpSteps[])
            .find((key) => SignUpStepRoutes[key] === location.pathname);

        if (step) {
            SUACService.setCurrentStep(step);
        }
    }, [location.pathname]);
    
    return (
        <div className="nav-bar">
            <ThriveAppLogo />

            <MinimalBreadcrumb
                currentStep={currentStepNumber + 1}
                totalSteps={TOTAL_SIGNUP_STEPS}
            />
        </div>
    )
}

export default NavBar